module.exports = __webpack_public_path__ + "img/fr.be825203.svg";